module.exports = __webpack_public_path__ + "img/Avatar-10.df73c8d8.svg";